'use client';

import { clsx } from 'clsx';
import { FC } from 'react';

import { IconHeart } from 'src/general/Icons/IconHeart';
import { IconHeartFilled } from 'src/general/Icons/IconHeartFilled';
import { ProductListDataRow } from 'src/types/CataloguePage.types';

import { Shade } from '../Shade/Shade';
import { useToggleWatchList } from './hooks/useToggleWatchList';

type AddToWatchListIconProps = {
  sku: string;
  disableSnackbar?: boolean;
  product?: Partial<ProductListDataRow>;
  onWatchlistStatusChange?: () => Promise<void>;
  variant?: 'default' | 'productCard';
};

export const AddToWatchListIcon: FC<AddToWatchListIconProps> = ({
  sku,
  product = {},
  onWatchlistStatusChange,
  disableSnackbar = false,
  variant = 'default',
}) => {
  const { userAddedItem, handleToggle, isLoading } = useToggleWatchList(
    sku,
    disableSnackbar,
    onWatchlistStatusChange,
    product,
  );

  return (
    <button
      type="button"
      className={clsx(
        'c-shade_container relative size-10 cursor-pointer overflow-hidden rounded-full p-2 transition-colors duration-200',
        {
          ['text-pin-500']: userAddedItem,
          ['bg-tex-inv-tie2 hover:bg-for-pri-lig focus:bg-for-pri-lig']: variant === 'default',
          ['c-shade_container--grey']: variant === 'productCard',
        },
      )}
      onClick={handleToggle}
      data-testid={`AddToWatchList-component-button-${userAddedItem ? 'Saved' : 'Save'}`}
      title="Add to watchlist"
      disabled={isLoading}
    >
      <Shade noBackground />
      {userAddedItem ? <IconHeartFilled /> : <IconHeart />}
    </button>
  );
};
